module.exports = __webpack_public_path__ + "img/icon_anonbud_gold.d996cd0d.svg";